import whyDidYouRender from '@welldone-software/why-did-you-render';
import React from 'react';

if (import.meta.env.VITE_LOG_RENDERS) {
  whyDidYouRender(React, {
    trackAllPureComponents: false,
    collapseGroups: true,
  });
}
